import script from "./rescheduleClass.vue?vue&type=script&setup=true&lang=js"
export * from "./rescheduleClass.vue?vue&type=script&setup=true&lang=js"

import "./rescheduleClass.vue?vue&type=style&index=0&id=b81faab8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b81faab8"]])

export default __exports__